import { Injectable } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {UserTypeEnum} from "../enums/user-type.enum";
import {AgencesVitrine} from "../const/agences-vitrine";
import {AgentsMandataires} from "../const/agents-mandataires";
import {SharedToolsService} from "../services/shared-tools.service";

@Injectable({ providedIn: 'root' })

export class UserTypeFormHelper {
	onTypeIdChange(value: any, param: string, formFields: any[], form:FormGroup, returnAnObjetList:boolean = false, sharedToolsService: SharedToolsService) {
		const item = formFields.find((f: any) => f.param === param);

		if (value === UserTypeEnum.PARTICULIER || value == UserTypeEnum.ENTREPRISE_BATIMENT) {
			this.removeFieldOnform(form, param, item);
		} else if (value === UserTypeEnum.AGENCE_VITRINE || value === UserTypeEnum.AGENT_MANDATAIRE) {
			this.addOrMakeParamRequired(form, param);

			if (item) {
				let list = (value === UserTypeEnum.AGENCE_VITRINE) ? AgencesVitrine : AgentsMandataires;
				let listObject = sharedToolsService.stringListToObjectList(list, 'USR_TYPE_REFERER');
				item.options = (returnAnObjetList) ? listObject : list;
				console.log('item.options ------------------------------------', item.options);
			}
		} else {
			this.removeFieldOnform(form, param, item);
		}
	}

	addOrMakeParamRequired(form:FormGroup, param: string) {
		if (!form.get(param)) {
			form.addControl(param, new FormControl(null, Validators.required));
		} else {
			form.get(param)?.setValue(null);
			form.get(param)?.setValidators([Validators.required]);
			form.get(param)?.updateValueAndValidity();
		}
	}

	removeFieldOnform(form:FormGroup, param: string, item: any) {
		form.removeControl(param);
		if (item) item.options = [];
	}
}
